export const environment = {
  firebase: {
    projectId: 'trainerswap-1c78a',
    appId: '1:154438053918:web:4f223dca4e0d3e38647e0f',
    storageBucket: 'trainerswap-1c78a.appspot.com',
    locationId: 'europe-west',
    apiKey: 'AIzaSyCywHHsjGu_Qpz_480vAe2tpDlTWFmTDJ8',
    authDomain: 'trainerswap-1c78a.firebaseapp.com',
    messagingSenderId: '154438053918',
    measurementId: 'G-R43SZDCD9N',
  },
    production: true
};
